import { render, staticRenderFns } from "./CreateProcessus.vue?vue&type=template&id=9e765f72&"
import script from "./CreateProcessus.vue?vue&type=script&lang=ts&"
export * from "./CreateProcessus.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProcessus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports